import React, { useRef, useState } from 'react';
import { FaCloudUploadAlt, FaFilePdf, FaTimes, FaSpinner, FaArrowRight } from 'react-icons/fa';

const UploadSection = ({ uploadedFiles, setUploadedFiles, onProcess, isProcessing }) => {
    const fileInputRef = useRef(null);
    const [isDragActive, setIsDragActive] = useState(false);

    const isPdfFile = (file) => {
        if (!file) return false;
        const nameEndsWithPdf = file.name && file.name.toLowerCase().endsWith('.pdf');
        const typeIsPdf = file.type && (file.type.includes('pdf') || file.type === 'application/pdf');
        return nameEndsWithPdf || typeIsPdf;
    };

    const handleFileChange = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            const filesArray = Array.from(e.target.files).filter(isPdfFile);
            setUploadedFiles(prev => [...prev, ...filesArray]);
        }
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        setIsDragActive(true);
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        setIsDragActive(false);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setIsDragActive(false);
        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            const filesArray = Array.from(e.dataTransfer.files).filter(isPdfFile);
            setUploadedFiles(prev => [...prev, ...filesArray]);
        }
    };

    const removeFile = (indexToRemove) => {
        setUploadedFiles(prev => prev.filter((_, index) => index !== indexToRemove));
    };

    return (
        <div className="bank-statement-card p-4">
            <h4 className="mb-1 text-dark fw-bold">Upload Bank Statements</h4>
            <p className="text-muted small mb-4">Select or drag & drop one or multiple PDF bank statements to parse and convert.</p>
            
            <div 
                className={`upload-area ${isDragActive ? 'active' : ''}`}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
                onClick={() => fileInputRef.current.click()}
            >
                <div className="upload-icon-wrapper">
                    <FaCloudUploadAlt size={36} />
                </div>
                <h5 className="text-dark fw-bold mb-1">Click or Drag PDF files here</h5>
                <p className="text-secondary small mb-0">Supports multiple statement files (.pdf)</p>
                <input 
                    type="file" 
                    multiple 
                    accept=".pdf,application/pdf" 
                    className="d-none" 
                    ref={fileInputRef} 
                    onChange={handleFileChange} 
                />
            </div>

            {uploadedFiles.length > 0 && (
                <div className="file-list mt-4">
                    <div className="d-flex align-items-center justify-content-between mb-3">
                        <h6 className="fw-bold text-dark m-0">Selected PDF Files ({uploadedFiles.length})</h6>
                        <button 
                            className="btn btn-sm btn-link text-danger text-decoration-none p-0 fw-semibold" 
                            onClick={() => setUploadedFiles([])}
                        >
                            Clear All
                        </button>
                    </div>
                    {uploadedFiles.map((file, index) => (
                        <div key={index} className="file-item">
                            <div className="file-item-info">
                                <div className="file-item-icon">
                                    <FaFilePdf size={18} />
                                </div>
                                <div>
                                    <div className="fw-bold text-dark fs-6">{file.name}</div>
                                    <div className="text-muted small">{(file.size / 1024 / 1024).toFixed(2)} MB</div>
                                </div>
                            </div>
                            <button className="btn-remove" onClick={() => removeFile(index)} title="Remove file">
                                <FaTimes />
                            </button>
                        </div>
                    ))}
                    <div className="mt-4 text-end">
                        <button 
                            type="button"
                            className="process-submit-btn" 
                            onClick={onProcess}
                            disabled={isProcessing || uploadedFiles.length === 0}
                        >
                            {isProcessing ? <FaSpinner className="fa-spin" /> : null}
                            {isProcessing ? 'Processing Statements...' : 'Process Statements'}
                            {!isProcessing && <FaArrowRight size={14} className="ms-1" />}
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default UploadSection;